import Proxy from '../Proxy';

class ManagerProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('managers', parameters);
  }
}

export default ManagerProxy;
